const useTipoNegociacaoV2 = () => {
  const negociacoesDisponiveis = [
    { label: "Condição Especial", value: 1 },
    { label: "Faixa", value: 3 },
  ];

  return {
    optionNegociacoes: negociacoesDisponiveis,
  };
};

export default useTipoNegociacaoV2;
